var indexOf = [].indexOf;

import {
  colorPickerColors
} from 'constants/colors';

import plural from 'helpers/plural';

angular.module('gym.calendar').controller('NewAppointmentCtrl', ["$scope", "$rootScope", "$stateParams", "$state", "$modal", "$modalInstance", "$http", "$timeout", "$filter", "flash", "AppointmentTypes", "EventDefaultsService", "TrainersService", "EmploymentService", "EventService", "ContactBadgeService", "FeatureAvailabilityService", "MonthlyOccurrenceOptionsService", "GTMService", "Contacts", "Locations", "ConfirmLeaveUnsavedChangesService", "EventTypes", "EditEventService", "GradingStyles", "params", function($scope, $rootScope, $stateParams, $state, $modal, $modalInstance, $http, $timeout, $filter, flash, AppointmentTypes, EventDefaultsService, TrainersService, EmploymentService, EventService, ContactBadgeService, FeatureAvailabilityService, MonthlyOccurrenceOptionsService, GTMService, Contacts, Locations, ConfirmLeaveUnsavedChangesService, EventTypes, EditEventService, GradingStyles, params) {
  var buildAppointment, buildParams, classrooms, dateToArray, getContactStatus, getStyles, gym, isAllContactsReady, isAppointmentReady, isCustomColorSelected, ref, reloadEventTypes, reloadLocations, setErrorStatus;
  $scope.gym = gym = $rootScope.gym;
  $scope.permissions = EmploymentService.get().permissions;
  if (!($scope.permissions.manage_events && FeatureAvailabilityService.isAvailable('attendance'))) {
    $state.go('gym.dashboard');
  }
  GTMService.trackPage('Add Appointment');
  $scope.classrooms = classrooms = $rootScope.gym.locations;
  if (params.contact_id) {
    Contacts.get(params.contact_id).then(function(contact) {
      $scope.contact = contact;
      return $scope.pageParams.addedContacts.push(contact);
    });
  }
  reloadEventTypes = function() {
    return EventTypes.getList({
      count: 1000
    }).then(function(types) {
      return $scope.eventTypes = types;
    });
  };
  reloadEventTypes();
  $scope.manageTypes = function() {
    return EditEventService.manageTypes($scope.eventTypes).result.then(function() {
      return reloadEventTypes();
    }, function() {
      return reloadEventTypes();
    });
  };
  getStyles = function() {
    if (gym.is_martial_arts) {
      return $scope.styles = GradingStyles.getList({
        count: 1000,
        slim: 1
      }).$object;
    }
  };
  getStyles();
  $scope.close = function(skipConfirmation) {
    if ($scope.displayConfirmationOnClose && !skipConfirmation) {
      if (window.confirm("Are you sure? This will abandon any unsaved changes.")) {
        return $modalInstance.dismiss();
      }
    } else {
      return $modalInstance.dismiss();
    }
  };
  $scope.appointment = {
    user_id: parseInt($stateParams.trainerId) || window.currentUser.id,
    repeat_type: 'count',
    classroom_id: parseInt($stateParams.locationId) || ((ref = classrooms[0]) != null ? ref.id : void 0),
    cancel_before_number: 1,
    cancel_before_unit: 'day'
  };
  buildParams = angular.extend(params, $stateParams);
  angular.extend($scope.appointment, EventDefaultsService.build(buildParams));
  ConfirmLeaveUnsavedChangesService.watch($scope, 'appointment', {
    closeModal: function() {
      return $scope.close(true);
    }
  });
  $scope.instructors = TrainersService.get();
  $scope.appointmentTypes = AppointmentTypes.getList({
    count: 1000
  }).$object;
  $scope.days = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
  $scope.repeatIntervalUnits = [['day', 'day(s)', 'Daily'], ['week', 'week(s)', 'Weekly'], ['month', 'month(s)', 'Monthly']];
  $scope.restrictCancellationsUnits = [['minute', 'minute(s)'], ['hour', 'hour(s)'], ['day', 'day(s)']];
  $scope.eventColors = colorPickerColors;
  $scope.pageParams = {
    contactSearch: '',
    addedContacts: []
  };
  $scope.isCustomColorSelected = isCustomColorSelected = function() {
    var ref1;
    return $scope.appointment.color && (ref1 = $scope.appointment.color, indexOf.call($scope.eventColors, ref1) < 0);
  };
  $scope.setColor = function(color) {
    $scope.appointment.color = color;
    return $scope.appointment.customColor = void 0;
  };
  $scope.$on('colorpicker-closed', function(currentScope, color) {
    return $timeout(function() {
      return $scope.appointment.color = color.value;
    });
  });
  $scope.onIntervalUnitChanged = function() {
    return $scope.appointment.wdays = $scope.appointment.repeat_interval_unit === 'week' ? [moment().day()] : [];
  };
  $scope.onTypeChanged = function() {
    var type, typeId;
    typeId = $scope.appointment.appointment_type_id;
    type = _.find($scope.appointmentTypes, {
      id: typeId
    });
    $scope.recalculateEndTime();
    $scope.appointmentTypeParticipantLimit = type.participant_limit;
    $scope.participantLimitTooltip = `The selected Appointment Type has a capacity limit of ${plural('attendees', $scope.appointmentTypeParticipantLimit, true)}. However, this limit can be overridden on this page by adding more attendees: the limit for the appointment will automatically adjust to reflect the number of attendees specified.`;
    $scope.appointment.free_appointment = type.free_appointment;
    $scope.appointment.color = type.color;
    $scope.appointment.event_type_id = type.event_type_id;
    $scope.appointment.style_id = type.style_id;
    $scope.appointment.customColor = isCustomColorSelected() ? $scope.appointment.color : void 0;
    return $scope.checkAllContacts();
  };
  $scope.userChangedEndTime = false;
  $scope.autoSettingEndTime = false;
  $scope.$watch('appointment.end_time', function(newVal, oldVal) {
    if (!(moment(newVal).isValid() && !moment(newVal).isSame(moment(oldVal)))) {
      return;
    }
    if ($scope.autoSettingEndTime) {
      return $scope.autoSettingEndTime = false;
    } else {
      return $scope.userChangedEndTime = true;
    }
  });
  $scope.$watch('appointment.start_time', function(newVal, oldVal) {
    if (!(moment(newVal).isValid() && !moment(newVal).isSame(moment(oldVal)))) {
      return;
    }
    if (!$scope.userChangedEndTime) {
      $scope.autoSettingEndTime = true;
      return $scope.appointment.end_time = moment(newVal).add(60, 'minutes').toDate();
    }
  });
  $scope.recalculateEndTime = function() {
    var duration_number, duration_unit, startTime, type, typeId;
    startTime = moment($scope.appointment.start_time).clone();
    typeId = $scope.appointment.appointment_type_id;
    type = _.find($scope.appointmentTypes, {
      id: typeId
    });
    if (!type) {
      return;
    }
    duration_number = type.duration_number;
    duration_unit = type.duration_unit;
    return $scope.appointment.end_time = startTime.add(duration_number, duration_unit);
  };
  $scope.toggleDay = function(index) {
    var base;
    (base = $scope.appointment).wdays || (base.wdays = []);
    if ($scope.isDaySelected(index)) {
      return $scope.appointment.wdays = _.without($scope.appointment.wdays, index);
    } else {
      return $scope.appointment.wdays.push(index);
    }
  };
  $scope.isDaySelected = function(index) {
    var result;
    result = _.find($scope.appointment.wdays, function(day) {
      return day === index;
    });
    return result != null;
  };
  reloadLocations = function() {
    return Locations.getList({
      count: 200
    }).then(function(response) {
      return $scope.classrooms = response;
    });
  };
  $scope.manageLocations = function() {
    var locationsModal;
    locationsModal = $modal.open({
      template: require('templates/gyms/calendar/events/manage_locations.html.slim'),
      controller: 'ClassroomMgmtModalCtrl',
      resolve: {
        classrooms: function() {
          return $scope.classrooms;
        }
      }
    });
    return locationsModal.result.then(function() {
      return reloadLocations();
    }, function() {
      return reloadLocations();
    });
  };
  $scope.toggleRecurrence = function() {
    if (!$scope.appointment.isRecurring) {
      $scope.appointment.repeat_until = null;
      return $scope.appointment.repeats = null;
    }
  };
  $scope.repeatTypeChanged = function(type) {
    var formattedMaxDate, maxDate;
    $scope.appointment.repeat_type = type;
    if (type === 'count') {
      $scope.appointment.repeat_until = null;
    } else {
      $scope.appointment.repeats = null;
    }
    $scope.appointment.errors = {};
    if ($scope.appointment.repeats > 400) {
      $scope.appointment.errors.repeats = ['must be 400 or fewer'];
    }
    maxDate = moment($scope.appointment.start_date).add(13, 'months');
    if ($scope.appointment.repeat_until && moment($scope.appointment.repeat_until).isAfter(maxDate)) {
      formattedMaxDate = maxDate.format('MMM D, YYYY');
      $scope.appointment.errors.repeat_until = [`cannot be later than ${formattedMaxDate}`];
    }
    return $scope.checkAllContacts();
  };
  $scope.getContacts = function(search) {
    var url;
    url = `/gyms/${gym.id}/calendar/appointments/contact_search`;
    return $http.get(url, {
      params: {
        search: search
      }
    }).then(function(response) {
      return response.data;
    });
  };
  isAppointmentReady = function() {
    var a;
    a = $scope.appointment;
    return (!a.isRecurring || a.repeat_until || a.repeats) && a.appointment_type_id && a.classroom_id;
  };
  isAllContactsReady = function() {
    var allContacts, readyContacts;
    allContacts = $scope.pageParams.addedContacts;
    readyContacts = _.filter(allContacts, function(c) {
      var ref1;
      return ((ref1 = c.contactStatus) != null ? ref1.isLoaded : void 0) && c.contactStatus.bookings_valid;
    });
    return readyContacts.length && readyContacts.length === allContacts.length;
  };
  $scope.checkAllContacts = function() {
    return $scope.pageParams.addedContacts.forEach(function(contact) {
      return getContactStatus(contact, moment());
    });
  };
  setErrorStatus = function(index, message, requestTime) {
    var currentStatus;
    currentStatus = $scope.pageParams.addedContacts[index].contactStatus;
    if ((currentStatus != null ? currentStatus.requestTime : void 0) && currentStatus.requestTime.isAfter(requestTime)) {
      return;
    }
    return $scope.pageParams.addedContacts[index].contactStatus = {
      isLoaded: true,
      isLoading: false,
      bookings_valid: false,
      message: message,
      requestTime: requestTime
    };
  };
  getContactStatus = function(contact, requestTime) {
    var contactIndex, maxDate, queryParams, url;
    url = `/gyms/${gym.id}/calendar/appointments/contact_membership_status`;
    queryParams = {
      contact_id: contact.id
    };
    contactIndex = _.findIndex($scope.pageParams.addedContacts, {
      id: contact.id
    });
    if ($scope.appointment.repeats > 400) {
      setErrorStatus(contactIndex, 'review the error messages above and try again', requestTime);
      return;
    }
    maxDate = moment($scope.appointment.start_date).add(13, 'months');
    if ($scope.appointment.repeat_until && moment($scope.appointment.repeat_until).isAfter(maxDate)) {
      setErrorStatus(contactIndex, 'review the error messages above and try again', requestTime);
      return;
    }
    if (!$scope.pageParams.addedContacts[contactIndex].contactStatus) {
      $scope.pageParams.addedContacts[contactIndex].contactStatus = {};
    }
    if (!isAppointmentReady()) {
      return;
    }
    $scope.pageParams.addedContacts[contactIndex].contactStatus.isLoading = true;
    $scope.pageParams.addedContacts[contactIndex].contactStatus.isLoaded = false;
    angular.extend(queryParams, buildAppointment());
    return $http.post(url, queryParams).then(function(response) {
      var currentStatus, ref1, ref2;
      currentStatus = $scope.pageParams.addedContacts[contactIndex].contactStatus;
      if ((currentStatus != null ? currentStatus.requestTime : void 0) && currentStatus.requestTime.isAfter(requestTime)) {
        return;
      }
      return $scope.pageParams.addedContacts[contactIndex].contactStatus = {
        isLoaded: true,
        isLoading: false,
        bookings_valid: response.data.result.bookings_valid,
        requestTime: requestTime,
        message: (ref1 = response.data.result.booking_status.invalid) != null ? (ref2 = ref1[0]) != null ? ref2.validation_error : void 0 : void 0
      };
    }, function(response) {
      return setErrorStatus(contactIndex, 'check membership conditions', requestTime);
    });
  };
  $scope.onContactSelect = function(contact) {
    $scope.pageParams.contactSearch = '';
    if (!_.find($scope.pageParams.addedContacts, {
      id: contact.id
    })) {
      $scope.pageParams.addedContacts.push(contact);
      return getContactStatus(contact, moment());
    }
  };
  $scope.displayContactStatus = function(contact) {
    if (contact.type === 'member') {
      if ($scope.appointment.free_appointment) {
        return 'Free appointment';
      }
    } else {
      return 'Membership not required for prospects';
    }
  };
  $scope.removeContact = function(index) {
    return $scope.pageParams.addedContacts.splice(index, 1);
  };
  $scope.isFormReady = function() {
    return isAppointmentReady() && isAllContactsReady() && !$scope.isLoading;
  };
  $scope.getContactBadge = function(type, status) {
    return ContactBadgeService.get(type, status);
  };
  $scope.displayRequireActiveMembershipDescription = function() {
    return EventService.displayRequireActiveMembershipDescription();
  };
  dateToArray = function(date, time) {
    var d, t;
    if (!time) {
      return null;
    }
    t = moment(time).toArray();
    d = moment(date).toArray();
    return [d[0], d[1] + 1, d[2], t[3], t[4]];
  };
  $scope.updateRecurrenceOptions = function() {
    var result;
    result = MonthlyOccurrenceOptionsService.generateRecurrenceOptions($scope.appointment, 'appointment');
    $scope.appointmentDropdownOptions = result.options;
    return $scope.appointmentRecurrenceDropdownHint = result.hint;
  };
  $scope.$watch('appointment.start_date', function(newVal, oldVal) {
    if (!(newVal && newVal !== oldVal)) {
      return;
    }
    return $scope.updateRecurrenceOptions();
  });
  $scope.updateRecurrenceOptions();
  buildAppointment = function() {
    var appointment, data;
    appointment = angular.copy($scope.appointment);
    if (!appointment.restrict_cancellations) {
      appointment.cancel_before_number = void 0;
      appointment.cancel_before_unit = void 0;
    }
    data = {
      start_at: dateToArray(appointment.start_date, appointment.start_time),
      end_at: dateToArray(appointment.start_date, appointment.end_time)
    };
    angular.extend(data, appointment);
    return data;
  };
  return $scope.save = function() {
    var appointment, url;
    GTMService.trackPage('Add Appointment', 'attempt');
    url = `/gyms/${gym.id}/calendar/appointments`;
    if ($scope.appointment.isRecurring && !$scope.appointment.repeat_interval_number) {
      flash.error = 'Please specify when this appointment should repeat';
      return;
    }
    $scope.isLoading = true;
    appointment = buildAppointment();
    appointment.contact_ids = $scope.pageParams.addedContacts.map(function(c) {
      return c.id;
    });
    return $http.post(url, {
      appointment: appointment
    }).then(function(response) {
      $rootScope.$emit('calendar:updated');
      $scope.close(true);
      return GTMService.trackPage('Add Appointment', 'success');
    }, function(response) {
      $scope.isLoading = false;
      GTMService.trackPage('Add Appointment', 'error');
      flash.error = "Save failed. Please fix the errors below";
      $scope.appointment.errors = response.data.appointment.errors;
      return angular.extend($scope.appointment.errors, response.data.errors.events, response.data.errors.bookings);
    });
  };
}]);
